import React, { useCallback } from 'react';
import { BsCreditCard, BsEye } from 'react-icons/bs';
import { AnimatedContainer } from '../styles';
import { StepIndicator } from '../components/StepIndicator';
import { ComponentUserRegisterProps, stepLabels } from '..';
import {
  ActionContainer,
  InfoContainer,
  LabelContainer,
  LineSeparator,
  LinkContainer,
  MonthPriceWrapper,
  OptionsContainer,
  PaymentOptionWrapper,
  PriceContainer,
  PriceItem,
  SubscriptionContainer,
  SubscriptionContent,
  TextContainer,
  TotalPriceWrapper,
  WarningContainer,
} from './styles';

import watch from '../../../assets/watch.svg';
import { PaymentMethodEnum } from '../../../enums/PaymentMethodEnum';
import { useUser } from '../../../hooks/user';
import { Subscriber } from '../../../entities/Subscriber';

import PixIcon from '../../../assets/pix-icon.svg';

export const Subscription: React.FC<ComponentUserRegisterProps> = ({
  nextPage,
}) => {
  const { setUser } = useUser();

  const handlePaymentSelection = useCallback(
    (paymentMethod: PaymentMethodEnum) => {
      setUser((prev: Subscriber) => ({
        ...prev,
        paymentMethod,
      }));

      nextPage();
    },
    [setUser, nextPage],
  );

  return (
    <AnimatedContainer>
      <StepIndicator activeIndex={0} titles={stepLabels} />
      <h1>Assinatura</h1>
      <InfoContainer>
        <span>Como funciona a assinatura?</span>
        <LinkContainer>
          <BsEye size={16} />
          <span>Contrato de prestação de serviços</span>
        </LinkContainer>
      </InfoContainer>
      <SubscriptionContainer>
        <img src={watch} alt="watch" />
        <SubscriptionContent>
          <h1>Assistente Virtual</h1>
          <PriceContainer>
            <PriceItem>
              <TotalPriceWrapper>
                <div className="priceSection">
                  <span>R$ 290,00 no Cartão/Pix</span>
                </div>
              </TotalPriceWrapper>
              <MonthPriceWrapper>
                <span>
                  R$ 40,00 Mensais{' '}
                  <span className="additionalPrice">+ R$ 205,00</span>
                </span>
              </MonthPriceWrapper>
            </PriceItem>
          </PriceContainer>
          <LineSeparator />
          <TextContainer>
            <p>
              Você paga <span>R$ 40,00/mês+R$ 250,00</span> do dispositivo
              (apenas na primeira vez). Com a Cinco você pode cancelar quando
              quiser e sem burocracias.
            </p>
          </TextContainer>

          <WarningContainer>
            <p>
              <span>IMPORTANTE:</span> O Modelo da pulseira inteligente pode
              variar da imagem apresentada mediante ao estoque.
            </p>
          </WarningContainer>
        </SubscriptionContent>
      </SubscriptionContainer>
      <OptionsContainer>
        <p>Escolha uma forma de pagamento:</p>
        <PaymentOptionWrapper
          onClick={() => handlePaymentSelection(PaymentMethodEnum.CreditCard)}
        >
          <LabelContainer>
            <BsCreditCard size={22} />
            <span>Cartão de crédito</span>
          </LabelContainer>
          <ActionContainer>
            <span>Selecionar</span>
          </ActionContainer>
        </PaymentOptionWrapper>
        <PaymentOptionWrapper
          onClick={() => handlePaymentSelection(PaymentMethodEnum.Pix)}
        >
          <LabelContainer>
            <img src={PixIcon} alt="Pix" />
            <span>Pix</span>
          </LabelContainer>
          <ActionContainer>
            <span>Selecionar</span>
          </ActionContainer>
        </PaymentOptionWrapper>
      </OptionsContainer>
    </AnimatedContainer>
  );
};
